const localStorageNamePrefix = "cs"
export default {
  lang: `${localStorageNamePrefix}-lang`,
}
